export const YES_NO = ['是', '否'];

export const ORDER_STATUS = ['未付款', '待接单', '已接单', '已取消', '已支付尾款', '服务已完成'];
export const REFUND_STATUS = ['未退款', '退款中', '退款成功', '拒绝退款'];

export const ORDER_PAY_TYPE = {
  1: '支付宝支付',
  2: '微信支付',
};



// WEBPACK FOOTER //
// ./src/constants.js